import { render, staticRenderFns } from "./PerksSlider.vue?vue&type=template&id=1a772ec4&"
import script from "./PerksSlider.vue?vue&type=script&lang=js&"
export * from "./PerksSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports